import './callMeBack.scss';

import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { i18n } from 'core/i18n';
import { CALLMEBACK_GENESYS, CALLMEBACK } from 'constants/flagBasedFeatures';
import specialistsActions from 'actions/investmentSpecialists';
import BrokerInvestmentSpecialistModal from 'components/broker/brokerInvestmentSpecialistModal/brokerInvestmentSpecialistModal';
import OKModal from 'components/commons/OKModal/OKModal';

const { formatText, FormattedText } = i18n;

const BrokerIACallMeBack = ({
    immFlagBasedFeatures,
    immProfile,
    immInvestmentSpecialists,
    onToggleModal,
    onSetProfilePhone,
    onRequestBrokerCallTimeOptions,
    onCommentChange,
    onCallTimeChange,
    onTelChange,
    onTelCodeChange,
    onRequestCall,
}) => {
    const [, setShowContactForm] = useState(false);
    const [showErrorMessages, setShowErrorMessages] = useState(false);

    const handleContactModalToggle = () => {
        setShowContactForm(showContactForm => !showContactForm);
        onToggleModal();
    };

    const handleRequestCall = () => {
        const isCallMeBackGenesysEnabled = immFlagBasedFeatures.get(CALLMEBACK_GENESYS);
        onRequestCall(isCallMeBackGenesysEnabled);

        if (immInvestmentSpecialists.get('valid')) {
            handleContactModalToggle();
        } else {
            setShowErrorMessages(true);
        }
    };

    const contentModal = (
        <BrokerInvestmentSpecialistModal
            immInvestmentSpecialists={immInvestmentSpecialists}
            immProfile={immProfile}
            onTelCodeChange={onTelCodeChange}
            onTelChange={onTelChange}
            onCallTimeChange={onCallTimeChange}
            onCommentChange={onCommentChange}
            onCloseClick={handleContactModalToggle}
            onRequestCall={handleRequestCall}
            onRequestBrokerCallTimeOptions={onRequestBrokerCallTimeOptions}
            onSetProfilePhone={onSetProfilePhone}
            showErrorMessages={showErrorMessages}
        />
    );

    return (
        <div className="brokerIA-callback__container">
            <div className="brokerIA-callback__header">{formatText('brokerIA-callback_title')}</div>
            <div className="brokerIA-callback__content">
                <div>
                    <div className="brokerIA-callback__description">
                        {formatText('brokerIA-callback_description')}
                    </div>
                    {immFlagBasedFeatures.get(CALLMEBACK) && (
                        <div className="broker-investment-specialist__entrance">
                            <span className="broker-investment-specialist__entrance-text">
                                {formatText('callmeback-entrance')}{' '}
                            </span>
                            <span
                                className="broker-investment-specialist__entrance-here"
                                onClick={handleContactModalToggle}
                            >
                                {formatText('callmeback-here')}
                            </span>
                        </div>
                    )}
                </div>

                <div className="broker-investment-specialist__contact-options">
                    <FormattedText
                        className="broker-investment-specialist__contact-options__phone-number"
                        value="brokerInvestmentSpecialist-brokerInvestmentSpecialistPhone"
                    />
                    <FormattedText
                        className="broker-investment-specialist__contact-options__e-mail"
                        value="brokerInvestmentSpecialist-brokerInvestmentSpecialistEmail"
                    />
                </div>
            </div>
            <OKModal
                content={contentModal}
                footerType="navigation"
                isOpen={immInvestmentSpecialists.get('showModal')}
                onCloseCallback={handleContactModalToggle}
                onPrimaryButtonClick={handleRequestCall}
                onSecondaryButtonClick={handleContactModalToggle}
                primaryButtonText="brokerInvestmentSpecialistModal-request"
                primaryButtonLoading={immInvestmentSpecialists.get('requestingCall')}
                secondaryButtonText="brokerInvestmentSpecialistModal-cancel"
            />
        </div>
    );
};

BrokerIACallMeBack.propTypes = {
    immFlagBasedFeatures: PropTypes.object,
    immInvestmentSpecialists: PropTypes.object,
    immProfile: PropTypes.object,
    onToggleModal: PropTypes.func.isRequired,
    onTelCodeChange: PropTypes.func.isRequired,
    onTelChange: PropTypes.func.isRequired,
    onCallTimeChange: PropTypes.func.isRequired,
    onCommentChange: PropTypes.func.isRequired,
    onRequestCall: PropTypes.func.isRequired,
    onRequestBrokerCallTimeOptions: PropTypes.func.isRequired,
    onSetProfilePhone: PropTypes.func.isRequired,
};

export default connect(
    state => ({
        immFlagBasedFeatures: state.flagBasedFeatures,
        immInvestmentSpecialists: state.brokerInvestmentSpecialists,
        immProfile: state.profile,
    }),
    {
        onCallTimeChange: specialistsActions.changeCallTime,
        onCommentChange: specialistsActions.changeComment,
        onRequestBrokerCallTimeOptions: specialistsActions.requestBrokerCallTimeOptions,
        onRequestCall: specialistsActions.requestCall,
        onTelChange: specialistsActions.changeTel,
        onTelCodeChange: specialistsActions.changeTelCode,
        onToggleModal: specialistsActions.toggleModal,
        onSetProfilePhone: specialistsActions.setProfilePhone,
    }
)(BrokerIACallMeBack);
